module.exports = __webpack_public_path__ + "img/logo_rombo.4ee5fc6b.png";